import { getNumOfBytes } from '@/utils/getNumOfBytes';
/**
 * File max size
 * IC Submission
 */
export const IC_SUBMISSION_FILE_MAX_SIZE = getNumOfBytes(100, 'MiB');
/**
 * File max size
 * CNC Paydown Notice
 */
export const CNC_PAYDOWN_NOTICE_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');
/**
 *
 * C & C Servicer Report
 */
export const CNC_SERVICER_REPORT_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');
/**
 *
 * C & C Other Document
 */
export const CNC_OTHER_DOCUMENT_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');

export const CNC_FUNDING_REQUEST_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');

export const CNC_FINANCIAL_STATEMENTS_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');

export const CRE_FUNDING_REQUEST_FILE_MAX_SIZE = getNumOfBytes(4, 'GiB');
